import React, {Component} from "react";
import axios from "axios";
import AuthService from "../../../AuthService";

import defaultOption from "../../../img/icon/default_option.png";
import loader from "../../../img/loader.gif";

class SpecificBlockOption extends Component {
    constructor(props) {
        super(props);

        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        this.state = {
            croisiereId: this.props.blockItem.values[0],
            result: null,
            data: '',
            croisiereOptions: '',
            errors: ''
        }

        const e = {target: {name: name, value: this.props.blockItem.values[0]}};
        this.props.onChange(e);
        this.change = this.change.bind(this);
    }

    async componentDidMount() {
        await this.loadData();
    }

    async loadData() {
        await axios.post(AuthService.getUrl('/getCroisiereOption'), {
            croisiere: {
                id: this.state.croisiereId
            }
        }, AuthService.getAuthHeader()).then(res => {
            if (res.data.data.errors !== undefined) {
                this.setState({
                    errors: res.data.errors
                });
                return ;
            }

            this.setState({
                result: res.return,
                data: JSON.parse(JSON.stringify(res.data.data))
            });

            this.state.data.croisiereOptions.map(option => {
                this.setState({
                    ["TEMP_PARAM_optionCharged-" + option.id]: option.nbCharged === null ? 0 : option.nbCharged
                });
                this.setState({
                    ["TEMP_PARAM_optionFree-" + option.id]: option.nbFree === null ? 0 : option.nbFree
                });
                this.props.onChange({target: {name: "TEMP_PARAM_optionCharged-" + option.id, value: option.nbCharged === null ? 0 : option.nbCharged}});
                this.props.onChange({target: {name: "TEMP_PARAM_optionFree-" + option.id, value: option.nbFree === null ? 0 : option.nbFree}});
            });
            this.state.data.categorieExtra.map(category => {
                this.setState({
                    ['is_active_category_' + category.id] : false
                });
            });
        });
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        this.props.onChange(e);
    }

    upOption(name) {
        this.setState({
            [name]: this.state[name] + 1
        });
        this.props.onChange({target: {name: name, value: this.state[name] + 1}});
    }

    downOption(name) {
        this.setState({
            [name]: this.state[name] - 1
        });
        this.props.onChange({target: {name: name, value: this.state[name] - 1}});
    }

    async displayCategory(categoryId) {
        await this.setState({
            ['is_active_category_' + categoryId] : !this.state['is_active_category_' + categoryId]
        });
    }
    render() {
        if (this.state.result === null) {
            return (
                <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
            );
        } else {
            return (
                    <div style={{float: "left"}}>
                    <React.Fragment>
                        {this.state.data.categorieExtra.map(categorie => (
                            <React.Fragment>
                                <div id="option-categorie" style={{cursor: "pointer"}} onClick={() => this.displayCategory(categorie.id)}>
                                    {categorie.label}
                                    <i className="arrow right">
                                    </i>
                                </div>
                                    <div id={'croisiereOptionCategory' + categorie.id} >
                                        {this.state.data.croisiereOptions.map(option => (
                                            <React.Fragment>

                                                {option.categorieExtra.id === categorie.id && this.state['is_active_category_' + categorie.id] &&

                                                    <div className="croisiere-option">
                                                        <div className="croisiere-option-img"><img
                                                            src={!!option.img ? "data:image/png;base64," + option.img : defaultOption}/>
                                                        </div>
                                                        <div className="croisiere-option-label">Option - {option.label}</div>
                                                        <div className="croisiere-option-value">
                                                            <button type="button" className="croisiere-option-control"
                                                                    style={{borderRadius: "10px 10px 0px 0px"}}
                                                                    onClick={() => this.upOption("TEMP_PARAM_optionCharged-" + option.id)}>+
                                                            </button>
                                                            <input type="text"
                                                                   className="croisiere-option-input"
                                                                   autoComplete="off"
                                                                   name={"option-" + option.id}
                                                                   value={this.state["TEMP_PARAM_optionCharged-" + option.id]}
                                                                   onChange={this.change}/>
                                                            <button type="button" className="croisiere-option-control"
                                                                    style={{
                                                                        borderRadius: "0px 0px 10px 10px",
                                                                        lineHeight: "14px"
                                                                    }}
                                                                    onClick={() => this.downOption("TEMP_PARAM_optionCharged-" + option.id)}>-
                                                            </button>
                                                        </div>
                                                        <div className="croisiere-option-value">
                                                            <button type="button" className="croisiere-option-control2"
                                                                    style={{borderRadius: "10px 10px 0px 0px"}}
                                                                    onClick={() => this.upOption("TEMP_PARAM_optionFree-" + option.id)}>+
                                                            </button>
                                                            <input type="text"
                                                                   className="croisiere-option-input"
                                                                   autoComplete="off"
                                                                   name={"option-" + option.id}
                                                                   value={this.state["TEMP_PARAM_optionFree-" + option.id]}
                                                                   onChange={this.change}/>
                                                            <button type="button" className="croisiere-option-control2"
                                                                    style={{
                                                                        borderRadius: "0px 0px 10px 10px",
                                                                        lineHeight: "14px"
                                                                    }}
                                                                    onClick={() => this.downOption("TEMP_PARAM_optionFree-" + option.id)}>-
                                                            </button>
                                                        </div>
                                                    </div>
                                                }
                                            </React.Fragment>
                                        ))}
                                    </div>
                            </React.Fragment>
                        ))}
                    </React.Fragment>
                </div>
            )
        }
    }
}

export default SpecificBlockOption;
